// Auto-generated by scripts/generate-registry.mjs from packages/modules/chess_medals_round/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const chess_medals_round: ModuleSchema = {
  "id": "chess_medals_round",
  "uniqueId": "B3D_X45XY",
  "createdAt": "2026-10-24T14:47:39.305Z",
  "updatedAt": "2026-10-28T14:57:47.725Z",
  "label": "Round Chess Medal",
  "description": "Clone of Chess Medals with a circular checkerboard base",
  "category": "Accessories",
  "tags": [
    "chess-medals-round"
  ],
  "sliders": [
    {
      "key": "medal_size",
      "label": "Medal Round Diameter",
      "min": 40,
      "max": 120,
      "default": 65,
      "step": 1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "layer_thickness",
      "label": "Layer Thickness (x4 layers = Total Height)",
      "min": 1,
      "max": 5,
      "default": 2,
      "step": 0.5,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "explode_gap",
      "label": "Khoảng Cách Tách Lớp 3D (Explode Layer Gap)",
      "min": 0,
      "max": 30,
      "default": 10,
      "step": 1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "enableBottomWatermark",
      "label": "Bottom Brand Watermark (Z=0)",
      "min": 0,
      "max": 1,
      "default": 1,
      "step": 1,
      "unit": "",
      "enabled": true,
      "visible": true
    },
    {
      "key": "enableCavityWatermark",
      "label": "Anti-Theft Surface Brand Watermark",
      "min": 0,
      "max": 1,
      "default": 1,
      "step": 1,
      "unit": "",
      "enabled": true,
      "visible": true
    },
    {
      "key": "pieces_scale",
      "label": "Tỉ Lệ Kích Thước Cụm Con Cờ (Pieces Scale)",
      "min": 0.5,
      "max": 2.5,
      "default": 1.7,
      "step": 0.05,
      "unit": "x",
      "enabled": true,
      "visible": false
    },
    {
      "key": "pieces_offset_x",
      "label": "Dịch Trục X Cụm Con Cờ (Trái - / Phải +)",
      "min": -25,
      "max": 25,
      "default": 0,
      "step": 0.5,
      "unit": "mm",
      "enabled": true,
      "visible": false
    },
    {
      "key": "pieces_offset_y",
      "label": "Dịch Trục Y Cụm Con Cờ (Xuống - / Lên +)",
      "min": -25,
      "max": 25,
      "default": -4.5,
      "step": 0.5,
      "unit": "mm",
      "enabled": true,
      "visible": false
    },
    {
      "key": "text_scale",
      "label": "Tỉ Lệ Kích Thước Chữ / Số (Text Scale)",
      "min": 0.5,
      "max": 3.5,
      "default": 2.55,
      "step": 0.05,
      "unit": "x",
      "enabled": true,
      "visible": true
    },
    {
      "key": "text_offset_x",
      "label": "Dịch Trục X Chữ / Số (Trái - / Phải +)",
      "min": -25,
      "max": 25,
      "default": 0,
      "step": 0.5,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "text_offset_y",
      "label": "Dịch Trục Y Chữ / Số (Xuống - / Lên +)",
      "min": -25,
      "max": 25,
      "default": -3.5,
      "step": 0.5,
      "unit": "mm",
      "enabled": true,
      "visible": true
    }
  ],
  "selects": [],
  "textParams": [
    {
      "key": "text",
      "label": "Chữ Số / Nổi Trên Cùng (Rank Text)",
      "default": "1",
      "kind": "textarea",
      "enabled": true,
      "visible": true
    },
    {
      "key": "fontStyle",
      "label": "Font Family",
      "default": "roboto",
      "kind": "font",
      "enabled": true,
      "visible": true
    }
  ],
  "colorConfigs": [
    {
      "key": "layer1_white_base",
      "label": "Lớp 1: Đế Trắng Dưới Cùng (2mm)",
      "default": "#f8fafc",
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "layer2_black_checkerboard",
      "label": "Lớp 2: Ô Caro Đen + Đế Đen Cờ/Chữ (1mm)",
      "default": "#1e293b",
      "targetGroupIds": [
        1
      ]
    },
    {
      "key": "layer3_chess_pieces",
      "label": "Lớp 3: 2 Con Cờ + Mặt Đỡ Chữ (1mm)",
      "default": "#94a3b8",
      "targetGroupIds": [
        2
      ]
    },
    {
      "key": "layer4_rank_number",
      "label": "Lớp 4: Chữ / Số Nổi (2mm)",
      "default": "#f97316",
      "targetGroupIds": [
        4
      ]
    }
  ],
  "objects": [
    {
      "id": "obj_layer1",
      "label": "Lớp 1: Đế Trắng Dưới Cùng",
      "name": "Lớp 1: Đế Trắng Dưới Cùng",
      "color": "#f8fafc",
      "assembled_z_offset": 0,
      "exploded_z_offset": 0,
      "parts": [
        {
          "id": "layer1_white_base",
          "label": "Lớp 1: Đế Trắng Dưới Cùng (2mm)",
          "name": "Lớp 1: Đế Trắng Dưới Cùng (2mm)",
          "groupId": 0,
          "colorKey": "layer1_white_base",
          "defaultColor": "#f8fafc",
          "assembled_z_offset": 0,
          "exploded_z_offset": 0,
          "export_stl": true
        }
      ]
    },
    {
      "id": "obj_layer2",
      "label": "Lớp 2: Ô Caro Đen + Đế Đen Cờ/Chữ",
      "name": "Lớp 2: Ô Caro Đen + Đế Đen Cờ/Chữ",
      "color": "#1e293b",
      "assembled_z_offset": 0,
      "exploded_z_offset": 20,
      "parts": [
        {
          "id": "layer2_black_checkerboard",
          "label": "Lớp 2: Ô Caro Đen + Đế Đen Cờ/Chữ (1mm)",
          "name": "Lớp 2: Ô Caro Đen + Đế Đen Cờ/Chữ (1mm)",
          "groupId": 1,
          "colorKey": "layer2_black_checkerboard",
          "defaultColor": "#1e293b",
          "assembled_z_offset": 0,
          "exploded_z_offset": 20,
          "export_stl": true
        }
      ]
    },
    {
      "id": "obj_layer3",
      "label": "Lớp 3: 2 Con Cờ + Mặt Đỡ Chữ",
      "name": "Lớp 3: 2 Con Cờ + Mặt Đỡ Chữ",
      "color": "#94a3b8",
      "assembled_z_offset": 0,
      "exploded_z_offset": 40,
      "parts": [
        {
          "id": "layer3_chess_pieces",
          "label": "Lớp 3: 2 Con Cờ + Mặt Đỡ Chữ (1mm)",
          "name": "Lớp 3: 2 Con Cờ + Mặt Đỡ Chữ (1mm)",
          "groupId": 2,
          "colorKey": "layer3_chess_pieces",
          "defaultColor": "#94a3b8",
          "assembled_z_offset": 0,
          "exploded_z_offset": 40,
          "export_stl": true
        }
      ]
    },
    {
      "id": "obj_layer4",
      "label": "Lớp 4: Chữ / Số Nổi",
      "name": "Lớp 4: Chữ / Số Nổi",
      "color": "#f97316",
      "assembled_z_offset": 0,
      "exploded_z_offset": 60,
      "parts": [
        {
          "id": "layer4_rank_number",
          "label": "Lớp 4: Chữ / Số Nổi (2mm)",
          "name": "Lớp 4: Chữ / Số Nổi (2mm)",
          "groupId": 4,
          "colorKey": "layer4_rank_number",
          "defaultColor": "#f97316",
          "assembled_z_offset": 0,
          "exploded_z_offset": 60,
          "export_stl": true
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "id": "all",
      "label": "Download 3MF / STL - Full Medal Assembly (Phối Cảnh Tất Cả Các Lớp)"
    },
    {
      "id": "layer1_white_base",
      "label": "Export Lớp 1: Đế Trắng Dưới Cùng (2mm)",
      "groupIds": [
        0
      ]
    },
    {
      "id": "layer2_black_checkerboard",
      "label": "Export Lớp 2: Ô Caro Đen + Đế Đen Cờ/Chữ (1mm)",
      "groupIds": [
        1
      ]
    },
    {
      "id": "layer3_chess_pieces",
      "label": "Export Lớp 3: 2 Con Cờ + Mặt Đỡ Chữ (1mm)",
      "groupIds": [
        2
      ]
    },
    {
      "id": "layer4_rank_number",
      "label": "Export Lớp 4: Chữ / Số Nổi (2mm)",
      "groupIds": [
        4
      ]
    }
  ]
};
